import ScoringScale from "./Components/ScoringScale";

export default ScoringScale;
